import { icons, images } from '../../constants/searchAssets'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { ImageSourcePropType } from 'react-native'

export interface OnboardingCardsModel {
  image: ImageSourcePropType
  title: string
  text: string
  icon?: ImageSourcePropType
  name?: string
}

export const OnboardingCards: OnboardingCardsModel[] = [
  {
    image: images.onboardingCardWelcome,
    title: formatMessage(messages.onboardingScreen_welcome_title),
    text: formatMessage(messages.onboardingScreen_welcome_text),
  },
  {
    image: images.onboardingCardFinancing,
    title: formatMessage(messages.onboardingScreen_financing_title),
    text: formatMessage(messages.onboardingScreen_financing_text),
    icon: icons.onboardingFinancing,
    name: formatMessage(messages.onboardingScreen_financing_name),
  },
  {
    image: images.onboardingCardConstruction,
    title: formatMessage(messages.onboardingScreen_construction_title),
    text: formatMessage(messages.onboardingScreen_construction_text),
    icon: icons.onboardingConstruction,
    name: formatMessage(messages.onboardingScreen_construction_name),
  },
  {
    image: images.onboardingCardNotification,
    title: formatMessage(messages.onboardingScreen_notification_title),
    text: formatMessage(messages.onboardingScreen_notification_text),
    icon: icons.onboardingNotification,
    name: formatMessage(messages.onboardingScreen_notification_name),
  },
]
